import axios from 'axios';
import config from '../../assets/config.js';
import { createAsyncThunk } from '@reduxjs/toolkit';

const backendURL = config.apiURL;
const base_url =window.location.origin+"/";

export const userLogin = createAsyncThunk(
    'user-login',
    async (payload, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
            const { data } = await axios.post(
                `${base_url}api/login`,
                payload,
                config
            );
            // if(data.data?.accessToken){
            localStorage.setItem('token1', true);
            localStorage.setItem('token', data?.data?.accessToken);
            localStorage.setItem("appUserID", data?.data?.appUserID);

            // }
            return data;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data)
            } else {
                return rejectWithValue(error.response.data)
            }
        }
    }
);